var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionConvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DF1E25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0831 20.9414C11.0831 21.7234 10.4481 22.3578 9.66432 22.3578C8.88284 22.3578 8.25024 21.7234 8.25024 20.9414C8.25024 20.1593 8.88284 19.5261 9.66432 19.5261C10.4481 19.5261 11.0831 20.1593 11.0831 20.9414Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0831 17.5337C11.0831 18.3164 10.4481 18.9496 9.66432 18.9496C8.88284 18.9496 8.25024 18.3164 8.25024 17.5337C8.25024 16.7511 8.88284 16.1167 9.66432 16.1167C10.4481 16.1167 11.0831 16.7511 11.0831 17.5337Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0831 14.1267C11.0831 14.9093 10.4481 15.5431 9.66432 15.5431C8.88284 15.5431 8.25024 14.9093 8.25024 14.1267C8.25024 13.344 8.88284 12.7114 9.66432 12.7114C10.4481 12.7114 11.0831 13.344 11.0831 14.1267Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4863 24.3492C14.4863 25.1307 13.8514 25.7645 13.0705 25.7645C12.2866 25.7645 11.6541 25.1307 11.6541 24.3492C11.6541 23.5666 12.2866 22.9316 13.0705 22.9316C13.8514 22.9316 14.4863 23.5666 14.4863 24.3492Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4863 20.9414C14.4863 21.7234 13.8514 22.3578 13.0705 22.3578C12.2866 22.3578 11.6541 21.7234 11.6541 20.9414C11.6541 20.1593 12.2866 19.5261 13.0705 19.5261C13.8514 19.5261 14.4863 20.1593 14.4863 20.9414Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4863 17.5337C14.4863 18.3164 13.8514 18.9496 13.0705 18.9496C12.2866 18.9496 11.6541 18.3164 11.6541 17.5337C11.6541 16.7511 12.2866 16.1167 13.0705 16.1167C13.8514 16.1167 14.4863 16.7511 14.4863 17.5337Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4863 14.1267C14.4863 14.9093 13.8514 15.5431 13.0705 15.5431C12.2866 15.5431 11.6541 14.9093 11.6541 14.1267C11.6541 13.344 12.2866 12.7114 13.0705 12.7114C13.8514 12.7114 14.4863 13.344 14.4863 14.1267Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4863 10.7192C14.4863 11.5006 13.8514 12.1356 13.0705 12.1356C12.2866 12.1356 11.6541 11.5006 11.6541 10.7192C11.6541 9.93651 12.2866 9.30273 13.0705 9.30273C13.8514 9.30273 14.4863 9.93651 14.4863 10.7192Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 27.7567C17.8895 28.5382 17.2552 29.1731 16.4737 29.1731C15.6916 29.1731 15.0573 28.5382 15.0573 27.7567C15.0573 26.9741 15.6916 26.3391 16.4737 26.3391C17.2552 26.3391 17.8895 26.9741 17.8895 27.7567Z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 24.3492C17.8895 25.1307 17.2552 25.7645 16.4737 25.7645C15.6916 25.7645 15.0573 25.1307 15.0573 24.3492C15.0573 23.5666 15.6916 22.9316 16.4737 22.9316C17.2552 22.9316 17.8895 23.5666 17.8895 24.3492Z",
    fill: "#FEFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 20.9414C17.8895 21.7234 17.2552 22.3578 16.4737 22.3578C15.6916 22.3578 15.0573 21.7234 15.0573 20.9414C15.0573 20.1593 15.6916 19.5261 16.4737 19.5261C17.2552 19.5261 17.8895 20.1593 17.8895 20.9414Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 17.5337C17.8895 18.3164 17.2552 18.9496 16.4737 18.9496C15.6916 18.9496 15.0573 18.3164 15.0573 17.5337C15.0573 16.7511 15.6916 16.1167 16.4737 16.1167C17.2552 16.1167 17.8895 16.7511 17.8895 17.5337Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 14.1267C17.8895 14.9093 17.2552 15.5431 16.4737 15.5431C15.6916 15.5431 15.0573 14.9093 15.0573 14.1267C15.0573 13.344 15.6916 12.7114 16.4737 12.7114C17.2552 12.7114 17.8895 13.344 17.8895 14.1267Z",
    fill: "#FEFEFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8895 10.7192C17.8895 11.5006 17.2552 12.1356 16.4737 12.1356C15.6916 12.1356 15.0573 11.5006 15.0573 10.7192C15.0573 9.93651 15.6916 9.30273 16.4737 9.30273C17.2552 9.30273 17.8895 9.93651 17.8895 10.7192Z",
    fill: "#FEFEFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 31.1621C21.2915 31.9459 20.6583 32.5797 19.875 32.5797C19.0936 32.5797 18.4586 31.9459 18.4586 31.1621C18.4586 30.3806 19.0936 29.7468 19.875 29.7468C20.6583 29.7468 21.2915 30.3806 21.2915 31.1621Z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 27.7567C21.2915 28.5382 20.6583 29.1731 19.875 29.1731C19.0936 29.1731 18.4586 28.5382 18.4586 27.7567C18.4586 26.9741 19.0936 26.3391 19.875 26.3391C20.6583 26.3391 21.2915 26.9741 21.2915 27.7567Z",
    fill: "#FEFEFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 24.3492C21.2915 25.1307 20.6583 25.7645 19.875 25.7645C19.0936 25.7645 18.4586 25.1307 18.4586 24.3492C18.4586 23.5666 19.0936 22.9316 19.875 22.9316C20.6583 22.9316 21.2915 23.5666 21.2915 24.3492Z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 20.9414C21.2915 21.7234 20.6583 22.3578 19.875 22.3578C19.0936 22.3578 18.4586 21.7234 18.4586 20.9414C18.4586 20.1593 19.0936 19.5261 19.875 19.5261C20.6583 19.5261 21.2915 20.1593 21.2915 20.9414Z",
    fill: "#FEFEFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 17.5337C21.2915 18.3164 20.6583 18.9496 19.875 18.9496C19.0936 18.9496 18.4586 18.3164 18.4586 17.5337C18.4586 16.7511 19.0936 16.1167 19.875 16.1167C20.6583 16.1167 21.2915 16.7511 21.2915 17.5337Z",
    fill: "#FEFEFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2915 14.1267C21.2915 14.9093 20.6583 15.5431 19.875 15.5431C19.0936 15.5431 18.4586 14.9093 18.4586 14.1267C18.4586 13.344 19.0936 12.7114 19.875 12.7114C20.6583 12.7114 21.2915 13.344 21.2915 14.1267Z",
    fill: "#FEFEFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 27.7567C24.6947 28.5382 24.0621 29.1731 23.2801 29.1731C22.4968 29.1731 21.8636 28.5382 21.8636 27.7567C21.8636 26.9741 22.4968 26.3391 23.2801 26.3391C24.0621 26.3391 24.6947 26.9741 24.6947 27.7567Z",
    fill: "#FEFEFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 24.3492C24.6947 25.1307 24.0621 25.7645 23.2801 25.7645C22.4968 25.7645 21.8636 25.1307 21.8636 24.3492C21.8636 23.5666 22.4968 22.9316 23.2801 22.9316C24.0621 22.9316 24.6947 23.5666 24.6947 24.3492Z",
    fill: "#FEFEFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 20.9414C24.6947 21.7234 24.0621 22.3578 23.2801 22.3578C22.4968 22.3578 21.8636 21.7234 21.8636 20.9414C21.8636 20.1593 22.4968 19.5261 23.2801 19.5261C24.0621 19.5261 24.6947 20.1593 24.6947 20.9414Z",
    fill: "#FEFEFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 17.5337C24.6947 18.3164 24.0621 18.9496 23.2801 18.9496C22.4968 18.9496 21.8636 18.3164 21.8636 17.5337C21.8636 16.7511 22.4968 16.1167 23.2801 16.1167C24.0621 16.1167 24.6947 16.7511 24.6947 17.5337Z",
    fill: "#FEFEFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 14.1267C24.6947 14.9093 24.0621 15.5431 23.2801 15.5431C22.4968 15.5431 21.8636 14.9093 21.8636 14.1267C21.8636 13.344 22.4968 12.7114 23.2801 12.7114C24.0621 12.7114 24.6947 13.344 24.6947 14.1267Z",
    fill: "#FEFEFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6947 10.7192C24.6947 11.5006 24.0621 12.1356 23.2801 12.1356C22.4968 12.1356 21.8636 11.5006 21.8636 10.7192C21.8636 9.93651 22.4968 9.30273 23.2801 9.30273C24.0621 9.30273 24.6947 9.93651 24.6947 10.7192Z",
    fill: "#FEFEFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 24.3492C28.098 25.1307 27.4654 25.7645 26.6822 25.7645C25.9001 25.7645 25.2657 25.1307 25.2657 24.3492C25.2657 23.5666 25.9001 22.9316 26.6822 22.9316C27.4654 22.9316 28.098 23.5666 28.098 24.3492Z",
    fill: "#FEFEFE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 20.9414C28.098 21.7234 27.4654 22.3578 26.6822 22.3578C25.9001 22.3578 25.2657 21.7234 25.2657 20.9414C25.2657 20.1593 25.9001 19.5261 26.6822 19.5261C27.4654 19.5261 28.098 20.1593 28.098 20.9414Z",
    fill: "#FEFEFE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 17.5337C28.098 18.3164 27.4654 18.9496 26.6822 18.9496C25.9001 18.9496 25.2657 18.3164 25.2657 17.5337C25.2657 16.7511 25.9001 16.1167 26.6822 16.1167C27.4654 16.1167 28.098 16.7511 28.098 17.5337Z",
    fill: "#FEFEFE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 14.1267C28.098 14.9093 27.4654 15.5431 26.6822 15.5431C25.9001 15.5431 25.2657 14.9093 25.2657 14.1267C25.2657 13.344 25.9001 12.7114 26.6822 12.7114C27.4654 12.7114 28.098 13.344 28.098 14.1267Z",
    fill: "#FEFEFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 10.7192C28.098 11.5006 27.4654 12.1356 26.6822 12.1356C25.9001 12.1356 25.2657 11.5006 25.2657 10.7192C25.2657 9.93651 25.9001 9.30273 26.6822 9.30273C27.4654 9.30273 28.098 9.93651 28.098 10.7192Z",
    fill: "#FEFEFE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5016 20.9414C31.5016 21.7234 30.8684 22.3578 30.0852 22.3578C29.3037 22.3578 28.6705 21.7234 28.6705 20.9414C28.6705 20.1593 29.3037 19.5261 30.0852 19.5261C30.8684 19.5261 31.5016 20.1593 31.5016 20.9414Z",
    fill: "#FEFEFE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5016 17.5337C31.5016 18.3164 30.8684 18.9496 30.0852 18.9496C29.3037 18.9496 28.6705 18.3164 28.6705 17.5337C28.6705 16.7511 29.3037 16.1167 30.0852 16.1167C30.8684 16.1167 31.5016 16.7511 31.5016 17.5337Z",
    fill: "#FEFEFE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5016 14.1267C31.5016 14.9093 30.8684 15.5431 30.0852 15.5431C29.3037 15.5431 28.6705 14.9093 28.6705 14.1267C28.6705 13.344 29.3037 12.7114 30.0852 12.7114C30.8684 12.7114 31.5016 13.344 31.5016 14.1267Z",
    fill: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionConvert);
export default __webpack_public_path__ + "static/media/transaction-convert.3b7ac8a84aa67dd942e6b7d08019f91f.svg";
export { ForwardRef as ReactComponent };